<template>
  <div>
    <DynamicToggleCollapse :titles="[{id:'Geofence-filter',name:'Geofence Filter'},{id:'Device-filter',name:'Device filter'}]">
  <b-collapse id="Device-filter">
         <b-card>
          <DevicesListFilters
 @divicesFilterd="divicesFilterd"
 @merageFilterWithRequest="merageFilterWithRequest"
 :haseSupportFilter="true"
 
 /> 
         </b-card>
        </b-collapse>

      <b-collapse id="Geofence-filter">
         <b-card>
          <GeofencesListFilters 
  @geofencesFilterd="geofencesFilterd" 
  @merageGeofencesFilterWithRequest="merageGeofencesFilterWithRequest"
  />
         </b-card>
        </b-collapse>
</DynamicToggleCollapse>

    <!-- form report -->
    <b-card style="position: relative">

      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">

          <!-- devices  -->
          <b-col cols="6">
            <b-form-group
                :label="$t('Devices')"
                label-for="vi-devices-id">
              <v-select multiple :close-on-select="false"
                        v-model="request.devices"
                        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                        :getOptionLabel="d => d.name"
                        :options="[{name: $t('all'), id: 'all'},...devices]"
                        :reduce="d => d.id"
              />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <!-- geofence  -->
          <b-col cols="6">
            <b-form-group :label="$t('Geofence')">
              <v-select multiple :close-on-select="false"
                        v-model="request.geofences"
                        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                        :getOptionLabel="d => d.name"
                        :options="[{name:$t('all'), id: 'all'},...geofences]"
                        :reduce="d => d.id"
              />
              <small v-if="errors && ('geofences' in errors)" class="text-danger">
                {{ $t(errors['geofences'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col md="12" sm="12">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>


          <b-col cols="6">
            <b-form-group>
              <b-form-radio-group
                  id="btn-radios-1"
                  v-model="request.inside"
                  :options="[{text: $t('inside geofence'), value: true },{text: $t('outside geofence'), value: false }]"
                  name="radios-btn-default"
              />
            </b-form-group>
          </b-col>


        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div v-if="report_data">
  <DataTable
     :report_data="report_data" 
     :report_fields="report_fields"
     :filter_included_fields="filter_included_fields"
     :request="request"
     :errors="errors"
     :loading="dataTableloading||loading"
     :getReport="getReport"
     :total="total"
     :from="from"
     :to="to" 
     :sortData="sortData"
    />

</div> 


  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput,BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText,BCollapse
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref } from '@vue/composition-api'

import reportForm from '@/app/reports/landFillAreas/reportForm'
import GeofenceReportLogic from '@/app/reports/landFillAreas/logic'

import  DevicesListFilters from '@/views/reports/filters/DevicesListFilters.vue'
import FilterLogic   from  '@/views/reports/filters/filterLogic.js'

import GeofencesListFilters from './filters/geofences/GeofencesListFilters.vue'
import GeofenceFilterLogic  from './filters/geofences/filterLogic.js'

import DynamicToggleCollapse from '@/views/ui/toggle-collapse/DynamicToggleCollapse.vue'
import DataTable from '@/views/reports/data-table/DataTable.vue'

import  ReportOptions from  '@/views/reports/components/options.js'

   
    
export default {
  name: 'RainReport',
  components: {
    BRow, BCard,BFormCheckboxGroup, BTable,BPagination,BCollapse,
    BCol,BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput,flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    DevicesListFilters,
    DynamicToggleCollapse,
    GeofencesListFilters,
    DataTable
  
  },
  directives: { Ripple, },

  setup(props,{root}) {
    const geofencesFilterd=(data)=>{
  geofences.value=data;
}

 const divicesFilterd =(data)=>{      
       devices.value=data;
    }
    const merageFilterWithRequest = (data) => {

      delete data['type']
      if (data['isSupport'] == "all") {
        delete data['isSupport']
        delete request.value.isSupport
      }

      Object.assign(request.value, data);
    }


    const merageGeofencesFilterWithRequest=(data)=>{
      delete data['type']   
     
      Object.assign(request.value, data);
    }
    const {geofences}=GeofenceFilterLogic()

    const rangeDate = ref('')
    const tableRef = ref(null)
    
    const {  type } = reportForm()

   

    const { report_data, request, errors, loading, getReport, total, from, to,isSortDirDesc,sortBy ,dataTableloading} = GeofenceReportLogic()
    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }

    const {devices,filter_request}  =FilterLogic()



    const filter_included_fields= ['day','device','area','count','distances', 'totalDistance','enterExitTimes','durations','totalDurations','owner','contract' ]
  
    const report_fields=[
      {
        key: 'index',
        label:'id',
       
      },
      {
        key: 'day',
        label: 'day',
        sortable: true
      },
      {
        key: 'device',
        label: 'device',
        sortable: true
      },
      {
        key: 'device_category',
        label: 'device_category',
        sortable: true
      },
      {
        key: 'area',
        label:'area',
        sortable: true
      },
      {
        key: 'count',
        label: 'count',
        sortable: true
      },
      {
        key: 'distances',
        label: 'visit count',
        sortable: true
      },
      {
        key: 'totalDistance',
        label: 'total distance',
        sortable: true
      },
      {
        key: 'enterExitTimes',
        label: 'enter and exit times',
        sortable: true
      },
      {
        key: 'durations',
        label:'durations',
        sortable: true
      },
      
      {
        key: 'totalDurations',
        label: 'total durations',
        sortable: true
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },
    ]
     
    const perPageOptions = [5, 10, 25, 50, 100]

    const {pickerOptions} =ReportOptions(request.value)

    const report_wrapper = ref(null)

    

    


  

   

    return {
      report_data,filter_included_fields,report_fields, total, from, to,rangeDate,
      tableRef,
      getReport,
      perPageOptions,

      devices,
      geofences,
      type,

      pickerOptions,
      report_wrapper,
    

      request,
      loading,
      errors,
      filter_request,
      divicesFilterd,
      merageFilterWithRequest
      ,geofencesFilterd
      ,merageGeofencesFilterWithRequest
      ,sortData
      ,dataTableloading
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
